import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {AuthPages, PgDashboard, PgBusinessViews} from './pages/index';
import ProtectedRoute from './component/ProtectedRoute';

function App() {
    return (
        <>
            <Router>
                <Routes>
                    <Route path="/" element={<AuthPages.PgSignIn/>}/>
                    <Route path="/dashboard"
                           element={
                               <ProtectedRoute>
                                   <PgDashboard/>
                               </ProtectedRoute>
                           }/>
                    <Route path="/viewsLog"
                           element={
                               <ProtectedRoute>
                                   <PgBusinessViews/>
                               </ProtectedRoute>
                           }/>
                </Routes>
            </Router>
        </>
    );
}

export default App;
